'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiAt = function TiAt(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 6.7c-7.4 0-13.3 6-13.3 13.3s6 13.3 13.3 13.3c2.7 0 5.3-0.8 7.5-2.3 0.8-0.5 1-1.5 0.4-2.3-0.5-0.8-1.5-0.9-2.3-0.4-1.6 1.1-3.6 1.7-5.6 1.7-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10v0.8c0 1-0.7 1.7-1.7 1.7s-1.6-0.7-1.6-1.7v-5c0-0.9-0.8-1.6-1.7-1.6-0.7 0-1.3 0.4-1.6 1.1-0.9-0.7-2.1-1.1-3.4-1.1-3.2 0-5.8 2.6-5.8 5.8s2.6 5.8 5.8 5.8c1.7 0 3.3-0.8 4.4-2 0.9 1.2 2.3 2 3.9 2 2.8 0 5-2.2 5-5v-0.8c0-7.4-5.9-13.3-13.3-13.3z m0 15.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z' })
        )
    );
};

exports.default = TiAt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/at.js
// module id = 3546
// module chunks = 0